import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CommonHttpService {

  constructor(private http: HttpClient) { }

  public postData(url, data, options?) {
    return this.http.post(url, data, options).pipe(
      catchError(this.handleError)
    );
  }

  public get(url, options?) {
    return this.http.get(url, options);
  }

  public getDataById(url, id) {
    return this.http.get(url + '/' + id);
  }

  public updateData(url, data) {
    return this.http.put(url, data);
  }

  public deleteData(url, id) {
    return this.http.delete(url + '/' + id);
  }
  public deleteDataParams(url) {
    return this.http.delete(url);
  }

  private handleError(error: HttpErrorResponse) {
    let errorMessage = 'An error occurred';
    if (error.error instanceof ErrorEvent) {
      // Client-side error
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // Server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.error('HTTP Error:', errorMessage);
    return throwError(() => error);
  }

  //common services
  // public getIp() {
  //   return this.http.get('https://jsonip.com')
  // }

}

